import {AlertSeverity} from "@interstate/components/Alert/Types/alertTypes";

export class AlertableError extends Error {
  readonly severity: AlertSeverity;
  readonly title?: string | null;

  /**
   * @param message The alert message to display
   * @param severity The severity of the alert
   * @param title The optional alert title where:
   *   - `undefined` is an indication to use a default title
   *   - `null` overrides the default with no title
   */
  constructor(message: string, severity: AlertSeverity, title?: string | null) {
    super(message);
    this.severity = severity;
    this.title = title;
  }
}
